import axios from './../plugins/private-api-axios'

export const eventService = {
    urlPrefix: '/events',
    config: {
        headers: {
            Authorization: ''
        }
    },
    async getEvents (page, perPage) {
        let urlBuilder = {
            'skip': (page - 1) * perPage,
            'take': perPage,
            'OrderBy': '-CreatedOn'
        }

        try {
            return await axios.get(`${this.urlPrefix}?${new URLSearchParams(urlBuilder).toString()}`, this.config)
        } catch (e) {
            throw e
        }
    },
    async getEvent (eventId) {
        try {
            return await axios.get(`${this.urlPrefix}/${eventId}`, this.config)
        } catch (e) {
            throw e
        }
    },
    async getEventDetails (eventId) {
        try {
            return await axios.get(`${this.urlPrefix}/details/${eventId}`, this.config)
        } catch (e) {
            throw e
        }
    }
}

export const updateEventService = (accessToken) => {
    eventService.config.headers.Authorization = accessToken
}

export default eventService
